import React from "react";
import clsx from "clsx";
import { parse } from "query-string";
import { makeStyles } from "@material-ui/core/styles";
import { Box, List, ListItem, Grid, Typography } from "@material-ui/core";
import { SectionAlternate, CardBase, Hero } from "@components/organisms";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

//components
import { Profile, Settings } from './components';

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
  },
  section: {
    "& .section-alternate__content": {
      paddingTop: 0,
      marginTop: theme.spacing(-5),
      position: "relative",
      zIndex: 1,
    },
    "& .card-base__content": {
      padding: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3),
      },
    },
  },
  menu: {
    height: "auto",
  },
  list: {
    display: "inline-flex",
    overflow: "auto",
    flexWrap: "nowrap",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "column",
      marginRight: theme.spacing(-3),
      marginLeft: theme.spacing(-3),
    },
  },
  listItem: {
    marginRight: theme.spacing(2),
    flex: 0,
    [theme.breakpoints.up("md")]: {
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
      borderLeft: "2px solid transparent",
    },
  },
  listItemActive: {
    [theme.breakpoints.up("md")]: {
      borderLeft: `2px solid ${theme.palette.primary.dark}`,
    },
    "& .menu__item": {
      color: theme.palette.text.primary,
    },
  },
}));

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Box component="div" hidden={value !== index} {...other}>
      {value === index && children}
    </Box>
  );
};

const Account = (props = {}) => {
  const classes = useStyles();
  //let pageId = parse(window.location.search).pid || 'general';

  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleChangedIndex = (event, newValue) => {
    setSelectedIndex(newValue);
  };

  return (
    <div className={classes.root}>
      <Hero
        title={"My Account"}
        subtitle={"View profile information and account settings"}
      />
      <SectionAlternate className={classes.section}>
        <Paper className={classes.root}>
          <Tabs
            value={selectedIndex}
            onChange={handleChangedIndex}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="auto"
            centered
          >
            <Tab label="Profile" />
            {/* <Tab label="Settings" /> */}
          </Tabs>
        </Paper>
        <Grid container spacing={4}>
          <Grid item xs={12} md={12}>
            <CardBase withShadow align="left">
              <TabPanel value={0} index={selectedIndex}><Profile /></TabPanel>
              <TabPanel value={1}  index={selectedIndex}><Settings /></TabPanel>
            </CardBase>
          </Grid>
        </Grid>
      </SectionAlternate>
    </div>
  );
};

export default Account;
